
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_battery",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.Battery')
        },
        value() {
            return this.unitLmsgSensors.battery?.text//this.$t('Not defined')
        },
        icon() {
            return this.showIcon ? 'unit_dashboard__battery' : false
        }
    },
}
</script>

<style scoped>

</style>